<template>
  <el-dropdown trigger="click" @command="handleLogOut">
    <span class="el-dropdown-link">
      <span class="avator" />
      <i class="el-icon-caret-bottom" />
    </span>
    <el-dropdown-menu>
      <el-dropdown-item disabled>
        <i class="el-icon-user-solid" />
        <span>你好 {{ info.username }}</span>
      </el-dropdown-item>
      <el-dropdown-item command="center">
        <i class="el-icon-s-tools" />
        <span>个人设置</span>
      </el-dropdown-item>
      <el-dropdown-item divided command="logOut">
        <i class="el-icon-error" />
        <span>退出</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "RightMenu",
  computed: {
    ...mapState("user", ["info"]),
  },
  methods: {
    handleLogOut(command) {
      if (command === "logOut") {
        this.logOut();
      } else if (command === "center") {
        this.handleJump();
      }
    },
    logOut() {
      this.$store.dispatch("user/logOut").then(() => {
        this.$router.push("/login");
      });
    },
    handleJump() {
      this.$router.push("/profile");
    },
  },
};
</script>
<style lang="less" scoped>
.el-dropdown {
  .el-dropdown-link {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    &:hover {
      background-color: rgba(0, 0, 0, 0.025);
      cursor: pointer;
    }
    .avator {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      background-color: #64d9d6;
    }
    .el-icon-caret-bottom {
      position: absolute;
      right: -12px;
      bottom: 4px;
    }
  }
}
</style>